import { render, staticRenderFns } from "./InputTagJSON.vue?vue&type=template&id=1f09fe6c"
import script from "./InputTagJSON.vue?vue&type=script&lang=js"
export * from "./InputTagJSON.vue?vue&type=script&lang=js"
import style0 from "./InputTagJSON.vue?vue&type=style&index=0&id=1f09fe6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports